var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{attrs:{"id":"countdown-timer"}},[_c('Typography',{class:['time-left', { 'two-hour-warning': _vm.twoHoursLeft }],attrs:{"variant":"overline"}},[_c('FontAwesomeIcon',{attrs:{"id":"clock-icon","icon":_vm.faClock}}),_vm._v(" "+_vm._s(_vm.timeRemaining)+" ")],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }